import useServicesSoldTable from '@/hooks/table/useServicesSoldTable';
import TableToolBar from './TableToolBar';
import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import { GenericTable } from '@/components/common/tables/common/generic-table/GenericTable';

export function ServicesSoldTable<TData, TValue>() {
  const { isError, isLoading, isFetching, table, filtering, setFiltering } =
    useServicesSoldTable();

  if (isError) {
    return <ErrorMessage />;
  }

  return (
    <>
      <TableToolBar
        table={table}
        filtering={filtering}
        setFiltering={setFiltering}
        isFetching={isFetching}
      />

      <GenericTable table={table} isLoading={isLoading} />
    </>
  );
}
